import React, { Component } from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import enableAccordions from './contentRules/accordion/handlers';
import DefaultTemplateComponent from './DefaultTemplateComponent';
import { injectIntl } from 'react-intl';

class DefaultTemplate extends Component {
  componentDidMount() {
    enableAccordions();
  }

  render() {
    const { intl, content, settings } = this.props;
    const messagesLoaded = intl && !_isEmpty(intl.messages) ? true : false;

    if (!process.browser || !messagesLoaded) {
      return <DefaultTemplateComponent content={content} />;
    }

    const isWhitelabel = settings.company.isWhitelabel;
    const regExp = /{{(wt.*?)}}/g;

    if (isWhitelabel) {
      const matches = content.description.match(regExp);

      if (matches !== null && matches.length > 0) {
        matches.forEach(function (v, i) {
          let id = v.substring(2, v.length - 2);
          let translation = intl.formatMessage({
            id: id,
            defaultMessage: 'Tripx default message',
            description: 'Tripx default message',
          });
          content.description = content.description.replace(v, translation);
        });
      }
    } else {
      content.description = content.description.replace(regExp, '');
    }

    return <DefaultTemplateComponent content={content} />;
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings.value,
  };
}

export default connect(mapStateToProps, null)(injectIntl(DefaultTemplate));
